<template>
  <div class="electronic-rent-money">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <!--<div class="btn-box">-->
        <!--<button-confirm value="手动充值" @confirm="dialogVisible = true" />-->
        <!--<button-export-->
          <!--:href="exportUrl"-->
          <!--download="download.xls"-->
          <!--:beforeDownload="beforeDownload"-->
          <!--value="导出"/>-->
      <!--</div>-->
      <div style="display: flex;justify-content: space-between;line-height: 32px;">
        <div style="margin-right: 5px;">余额不足</div>
        <el-input
          placeholder="请输入金额"
          size="small"
          v-model="requestData.rentBalance"
          style="width: 180px;"
          v-on:blur="changeRentBalance()"
          @keyup.enter.native="search()">
          <template slot="append">元</template>
        </el-input>
        <button-cancel @cancel="showPushConfigDialog" value="推送配置" style="margin-left: 10px;" v-if="permissionCodes.indexOf('005008001') !== -1"/>
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-search placeholder="住户名称/房间号" @search="searchKey" />
        <button-export
          style="margin-left: 5px"
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('005008002') !== -1"
          value="导出"/>
      </div>

    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @wantChangeInput="wantChangeInput" @changeInputChange="changeInputChange" @changeSelection="changeSelection" @lookOver="lookOver" @deleteLine="deleteLine" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @settlementRow="settlementRow" :hasOperation="false" :operationArr="operationArr"  />

    <el-dialog :visible.sync="pushConfigDialogVisible" title="推送配置" width="600px">
      <el-form style="width: 420px;margin: 0 auto;">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">推送金额：</span>
          </div>
          <el-input v-model="balance" size="small" style="width: 280px;" type="number" v-on:blur="changeBalance()">
            <template slot="append">元</template>
          </el-input>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">更新模式：</span>
          </div>
          <el-select v-model="state" size="small" style="width: 280px">
            <el-option v-for="item in stateList" :key="item.code"
                       :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </div>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pushConfigDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="updateBalance" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogVisible"
      title="充值"
      width="600px">
      <el-form style="width: 420px;margin: 0 auto;">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">住户名称：</span>
          </div>
          <el-select
            v-model="rentCode"
            filterable
            remote
            reserve-keyword
            placeholder="请输入房号或企业关键词"
            :loading="enterpriseLoading"
            size="mini" style="width: 280px"
            :remote-method="enterpriseRemoteMethod">
            <el-option
              v-for="item in enterpriseList"
              :key="item.code"
              :label="item._label"
              :value="item.code">
            </el-option>
          </el-select>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">充值人姓名：</span>
          </div>
          <el-input v-model="personName" size="small" style="width: 280px;" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">充值人手机：</span>
          </div>
          <el-input v-model="personPhone" size="small" style="width: 280px;" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">充值金额：</span>
          </div>
          <el-input v-model="money" size="small" style="width: 280px;" type="number" v-on:blur="changeMoney()">
            <template slot="append">元</template>
          </el-input>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="recharge" size="small">确 定</el-button>
      </div>
    </el-dialog>


    <div>
      <transition name="right-slide">
        <div class="window-left-box" v-show="windowLeftBox">
          <div class="window-left-main">
            <div style="text-align: left;margin: 10px 0 20px 0;">
              <el-date-picker v-model="detailRentTimeArr" size="small" type="datetimerange"
                              :picker-options="pickerOptions2" range-separator="至"
                              start-placeholder="开始日期" end-placeholder="结束日期"
                              align="right" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </div>
            <table-main :selection="false" :hasOperation="false" :tableHead="detailRentTableHead" :tableData="detailRentTableData" :total="detailRentTotal" :pageNum="detailRentPageNum" :pageSize="detailRentPageSize" @changePagination="changeDetailRentPagination"/>
          </div>
          <div class="mask" @click.capture.stop="windowLeftBox = !windowLeftBox"></div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ElectronicManagement";
import { errorHandler } from "../../../utils/errorHandler";
import { bus } from "../../../utils/bus";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";
import ButtonCancel from "../../../components/Button/ButtonCancel";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "electronic-pay-record",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧用电",
          name: "electronic-over-view"
        },
        {
          value: "余额管理"
        }
      ],
      // addCustom: 'amount-add',
      exportUrl: "",
      payStatusList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "0",
          label: "未缴费"
        },
        {
          key: "1",
          label: "已缴费"
        }
      ],
      tableHead: [
        {
          prop: "roomNumber",
          label: "房间号"
        },
        {
          prop: "enterpriseName",
          label: "承租主体"
        },
        {
          prop: "rentBalance",
          label: "账户余额(元)"
        },
        {
          prop: "pushBalance",
          changeInput: true,
          label: "推送金额(元)"
        },
        {
          isLooking: true,
          label: "账户明细"
        }
      ],
      // {
      //   isLooking: true,
      //     label: '余额明细'
      // },
      operationArr: ["settlement", "delete"],
      // operationArr: ['delete'],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: "",
        rentBalance: ""
      },
      dialogVisible: false,
      enterpriseLoading: false,
      enterpriseList: [],

      rentCode: "",
      rentName: "",
      personName: "",
      personPhone: "",
      money: "",

      settlementDataVisible: false,
      settlementData: {},

      accountCode: "",
      accountName: "",

      windowLeftBox: false,
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      detailRentTableHead: [
        {
          prop: "changeTime",
          label: "变更时间"
        },
        {
          prop: "balanceAfterChange",
          label: "变更前金额(元)"
        },
        {
          prop: "changeAmount",
          label: "变更金额(元)"
        },
        {
          prop: "balanceBeforeChange",
          label: "变更后金额(元)"
        },
        {
          prop: "sourceOfChange",
          label: "变更来源"
        }
      ],
      detailRentTableData: [],
      detailRentCode: "",
      detailRentTotal: 0,
      detailRentPageSize: 10,
      detailRentPageNum: 1,
      detailRentTimeArr: [],

      pushConfigDialogVisible: false,
      balance: "",
      state: "0",

      stateList: [
        { code: "0", name: "更新未单独配置企业" },
        { code: "1", name: "更新所有企业" }
      ]
    };
  },
  created() {
    this.accountName = bus.global.accountName;
    this.accountCode = bus.global.accountCode;
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
    this.getCreateTime();
  },
  activated() {
    this.getPage();
  },
  methods: {
    getCreateTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.detailRentTimeArr[0] =
        year + "-" + month + "-" + date + " " + "00:00:00";
      this.detailRentTimeArr[1] =
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second;
    },
    // 关键词搜索
    enterpriseRemoteMethod(query) {
      this.enterpriseLoading = true;
      this.$axios
        .post(api.getEnterpriseList, {
          searchKey: query,
          isIncludeYq: "NO"
        })
        .then(res => {
          if (res.data.retCode === 1) {
            this.enterpriseLoading = false;
            let data = res.data.data;
            data.map(v => {
              if (v.roomInfoNumber) {
                v._label = `${v.enterpriseName}/${v.roomInfoNumber}`;
              } else {
                v._label = `${v.enterpriseName}`;
              }
            });
            this.enterpriseList = data;
          }
        })
        .catch(errorHandler("获取住户列表失败"));
    },
    beforeDownload() {
      this.exportUrl = `${api.exportElectricRoomMoney}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&rentBalance=${this.requestData.rentBalance}`;
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getElectricRentMoneyPage, reqData)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {
            v.code = v.rentCode;
            v.changeInputDisabled = true;
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取金额信息失败"));
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    search() {
      this.pageNum = 1;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    settlementRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.settlementData = data;
      this.settlementConfirm();
      // this.settlementDataVisible = true
    },
    // 结算
    settlementConfirm() {
      this.$confirm(
        `是否确定为${this.settlementData.rentName}结算账户余额？`,
        "温馨提示"
      )
        .then(() => {
          this.$axios
            .post(api.settlement, this.settlementData)
            .then(res => {
              if (res.data.retCode === 1) {
                nSuccess("结算成功");
                this.getPage();
              }
            })
            .catch(errorHandler("结算失败"));
        })
        .catch(() => {
          console.log("取消结算");
        });
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    changeMoney() {
      if (this.money && +this.money > 0) {
        this.money = parseFloat(this.money)
          .toFixed(2)
          .toString();
      } else {
        this.money = "1.00";
      }
    },

    changeRentBalance() {
      if (this.requestData.rentBalance) {
        this.requestData.rentBalance = parseFloat(this.requestData.rentBalance)
          .toFixed(2)
          .toString();
      } else {
        this.requestData.rentBalance = "";
      }
      this.search();
    },

    // 充值
    recharge() {
      let checkPhone = pattern.telephoneOrPhone.test(this.personPhone);
      if (!this.rentCode) {
        nError("请选择住户");
        return false;
      }
      if (!this.personName) {
        nError("请输入充值人姓名");
        return false;
      }
      if (!this.personPhone) {
        nError("请输入充值人手机");
        return false;
      } else {
        if (!checkPhone) {
          nError("手机格式不正确");
          return false;
        }
      }
      if (!this.rentCode) {
        nError("请输入充值金额");
        return false;
      }
      this.enterpriseList.map(v => {
        if (v.code === this.rentCode) {
          this.rentName = v.enterpriseName;
        }
      });
      this.$confirm(
        `是否确定为${this.rentName}充值${this.money}元？`,
        "温馨提示"
      )
        .then(() => {
          this.$axios
            .post(api.recharge, {
              rentCode: this.rentCode,
              rentName: this.rentName,
              personName: this.personName,
              personPhone: this.personPhone,
              money: this.money,
              accountCode: this.accountCode,
              accountName: this.accountName
            })
            .then(res => {
              if (res.data.retCode === 1) {
                nSuccess("操作成功");
                this.dialogVisible = false;
                this.rentCode = "";
                this.rentName = "";
                this.personName = "";
                this.personPhone = "";
                this.money = "";
              }
              this.getPage();
            })
            .catch(errorHandler("操作失败"));
        })
        .catch(() => {
          console.log("取消操作");
        });
    },

    // 删除
    deleteLine(code) {
      this.$axios
        .post(api.deleteElectricRentMoney, code)
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    },

    // 预配置
    wantChangeInput(data) {
      this.tableData.map(v => {
        if (v.rentCode === data.rentCode) {
          v.changeInputDisabled = false;
        }
      });
    },

    // 单个配置
    changeInputChange(data) {
      console.log(data)
      let reqData = {
        roomCode: data.roomCode,
        rentName: data.rentName,
        pushBalance: data.pushBalance
      };
      this.$axios
        .post(api.pushRoomBalanceConfig, reqData)
        .then(res => {
          nSuccess("配置成功");
          this.getPage();
        })
        .catch(errorHandler("配置失败"));
    },

    // 查询账户明细
    lookOver(row) {
      this.detailRentCode = row.roomCode;
      this.getAccountDetailsPage();
    },

    // 查询明细分页
    getAccountDetailsPage() {
      let startTime = "";
      let endTime = "";
      if (this.detailRentTimeArr) {
        if (this.detailRentTimeArr.length > 1) {
          startTime = this.detailRentTimeArr[0] || "";
          endTime = this.detailRentTimeArr[1] || "";
        }
      }
      this.$axios
        .post(api.getAccountDetailsPage, {
          pageSize: this.detailRentPageSize,
          pageNum: this.detailRentPageNum,
          startTime: startTime,
          endTime: endTime,
          roomCode: this.detailRentCode
        })
        .then(res => {
          this.windowLeftBox = true;
          let data = res.data.data;
          this.detailRentTableData = data.list;
          this.detailRentTotal = data.total;
        })
        .catch(errorHandler("查询失败"));
    },

    changeDetailRentPagination(data) {
      this.detailRentPageNum = data[0];
      this.detailRentPageSize = data[1];
      this.getAccountDetailsPage();
    },

    showPushConfigDialog() {
      this.$axios
        .get(api.getBalanceConfig, {})
        .then(res => {
          let data = res.data.data;
          this.balance = data.balance;
          this.state = data.state;
          this.pushConfigDialogVisible = true;
        })
        .catch(errorHandler("查询配置失败"));
    },

    changeBalance() {
      if (this.balance && +this.balance > 0) {
        this.balance = parseFloat(this.balance)
          .toFixed(0)
          .toString();
      } else {
        this.balance = "0";
      }
    },

    // 全部配置
    updateBalance() {
      this.$axios
        .post(api.updateBalance, {
          balance: +this.balance,
          state: this.state
        })
        .then(res => {
          nSuccess("配置成功");
          this.getPage();
          this.pushConfigDialogVisible = false;
        })
        .catch(errorHandler("配置失败"));
    }
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.enterpriseRemoteMethod();
      } else {
        this.rentCode = "";
        this.rentName = "";
        this.personName = "";
        this.personPhone = "";
        this.money = "";
      }
    },
    detailRentTimeArr(val) {
      this.detailRentPageNum = 1;
      this.getAccountDetailsPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
.form-line {
  margin: 5px 0 20px 0;
  display: flex;
  justify-content: flex-start;
}
.line-text {
  color: #48576a;
  font-size: 14px;
}
.textBox {
  display: inline-block;
  width: 130px;
  line-height: 32px;
  text-align: right;
}
.red {
  color: #ff0000;
}
</style>

<style lang="less">
.electronic-rent-money {
  .el-input__inner {
    padding: 0 0 0 15px;
  }
  .el-input--mini {
    .el-input__inner {
      height: 32px;
      line-height: 32px;
      text-align: center;
      padding: 0 10px;
    }
  }
  .el-dialog__header {
    text-align: left;
  }
  .el-input.is-disabled .el-input__inner {
    cursor: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ElectronicManagement/ElectronicRentMoney/ElectronicRentMoney.vue